import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';

export type ListOption<T> = {
  const: string | null;
  value: T;
  group?: string;
};

type ListSelectProps<T> = {
  options: ListOption<T>[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  render?: (value: T) => React.ReactNode;
};

const ListSelect = <T,>(props: ListSelectProps<T>) => {
  const labelText = props.label ?? 'Select an option';
  const label = props.required ? `${labelText} *` : labelText;

  const handleChange = (event: SelectChangeEvent) => {
    props.onChange(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="list-select-label">{label}</InputLabel>
      <Select
        key={props.value}
        onChange={handleChange}
        disabled={props.disabled}
        value={props.value}
        label={label}
        labelId="list-select-label"
      >
        {!props.required && (
          <MenuItem value={undefined}>
            <Typography color="text.disabled">None</Typography>
          </MenuItem>
        )}
        {props.options?.map((option) => (
          <MenuItem value={option.const!} key={option.const!}>
            {props.render ? props.render(option.value) : (option.value as string)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default ListSelect;
